export default "__VITE_ASSET__B47m2A9C__"